export default {
    dotDefaultColor:"green",
    dotPastColor:"gray",
    backgroundDefaultColor:"green"
}